GatorSurvey.app.service("surveyService", ['$http', SurveyService]);

function SurveyService($http) {

    var self = this;

     self.GetSurveysSelect = function () {
         return $http.get("api/survey/SelectScreen").then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };
    
    self.GetSurveys = function () {
        return $http.get("api/survey/getall").then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    self.GetSurvey = function (surveyId) {
        return $http.get("api/survey/" + surveyId).then(function (response) {
            return response.data;
        },
        function (response)
        {
            throw (response.data);
        });
    };
    self.GetSurveyResults = function (surveyId) {
        return $http.get("api/survey/" + surveyId + "/results").then(function (response) {
            return response.data;
        },
        function (response)
        {
            throw (response.data);
        });
    };
    self.GetSurveyPublishScreen = function (surveyId) {
        return $http.get("api/survey/" + surveyId + "/publishScreen").then(function (response) {
            return response.data;
        },
        function (response) {
            throw (response.data);
        });
    };
    self.CreateNewSurvey = function (name, surveyId, isMySurvey, folderId) {
        return $http.post("api/survey/createnew", { Name: name, SurveyId: surveyId, isMySurvey: isMySurvey , folderId:  folderId }).then(function (response) {
            return response.data;
        },
        function (response)
        {
            throw (response.data);
        });
    };

    self.CreateNewSurveyWithStyle = function (name, surveyId, isMySurvey, styleId, folderId) {
        return $http.post("api/survey/createnew", { Name: name, SurveyId: surveyId, StyleId: styleId, isMySurvey: isMySurvey, folderId:  folderId}).then(function (response) {
            return response.data;
        },
        function (response) {
            throw (response.data);
        });
    };

    self.UpdateSurvey = function (survey) {
        return $http.post("api/survey/set/", survey).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };
    self.UpdatePublishSurvey = function (survey) {
        var json = JSON.stringify(survey,
            function (key, value) {
                if (["createddt", "enddate", "startdate", "updateddate"].indexOf(key.toLowerCase()) !== -1 && value) {
                    var dateValue = new Date(value);
                    return moment(dateValue).format("YYYY-MM-DDTHH:mm:ss");
                }

                return value;
            });

        return $http.post("api/survey/updatePublishSurvey/", json).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };
    self.DeleteSurvey = function (surveyId) {
        return $http.post("api/survey/" + surveyId + "/delete").then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data); 
        });
    };
    
    self.DeletePage = function (surveyId, pageId) {
        return $http.post("api/survey/" + surveyId + "/page/" + pageId).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    self.DeleteElement = function (surveyId, elementId) {
        return $http.post("api/survey/" + surveyId + "/element/" + elementId).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    self.CreateUpdatePage = function (surveyId, pageModel) {
        return $http.post("api/survey/" + surveyId + "/page/set", pageModel).then(function (response) { 
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    self.CreateUpdateElementOrderNo = function (surveyId, elementsOrder) {
        return $http.post("api/survey/" + surveyId + "/elements/reorder", elementsOrder).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    self.CreateUpdateElement = function (surveyId, pageId, element) {
        return $http.post("api/survey/" + surveyId + "/page/" + pageId + "/element", element).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    self.DeleteSubQuestion = function (surveyId, subQuestionId) {
        return $http.post("api/survey/" + surveyId + "/subquestion/" + subQuestionId).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };
    
    self.SaveSurvey = function(surveyData, surveyOriginal, surveyId) {
        return $http.post("api/survey/" + surveyId + "/save/", surveyData).then(function (response) {
            return response.data;
        }, function (response) {
            throw (response.data);
        });
    };

    self.GetDemoMode = function () {
        return $http.get("api/user/isdemomode").then(function (response) {
            return response.data;
        },
        function (response) {
            throw (response.data);
        });
    };

    self.publish = function (surveyId) {
        return $http.post("api/survey/" + surveyId + "/publish").then(function (response) {
            return response.data;
        },
        function (response) {
            throw (response.data);
        });
    };

    self.unpublish = function (surveyId) {
        return $http.post("api/survey/" + surveyId + "/unpublish").then(function (response) {
            return response.data;
        },
        function (response) {
            throw (response.data);
        });
    };

    self.updateQuestionText = function(surveyId, questionData) {
        return $http.post("api/survey/" + surveyId + "/questionText", questionData).then(function (response) {
            return response.data;
        },
        function (response) {
            throw (response.data);
        });
    };

    self.utmAddUpdate = function (surveyId,utms) {
        return $http.post("api/Survey/" + surveyId + "/utmredirect/add", utms).then(function (response) {
            return response.data;
        },
        function (response) {
            throw (response.data);
        });
    };

    self.utmDelete = function (surveyId,utm) {
        return $http.post("api/Survey/" + surveyId + "/utmredirect/delete/" + utms).then(function (response) {
            return response.data;
        },
        function (response) {
            throw (response.data);
        });
    };

    self.utmGet = function (id) {
        return $http.get("api/utmredirect/" + id).then(function (response) {
            return response.data;
        },
        function (response) {
            throw (response.data);
        });
    };

    self.duplicateSurvey = function(surveyId, newSurveyName) {
        return $http.post("api/survey/duplicateSurvey/", { SurveyToCopyId: surveyId, NewSurveyName: newSurveyName }).then(function(response) {
                return response.data;
            },
            function(response) {
                throw (response.data);
            });
    };

    self.changeFolder = function (surveyId, folderId)  {
        return $http.post("api/survey/move", { surveyId: surveyId, folderId: folderId }).then(function (response) {
                return response.data;
            },
            function (response) {
                throw (response.data);
            });
    };

    self.getRetakeOptions = function (surveyId) {
        return $http.get("api/survey/" + surveyId + "/retakeOptions").then(function (response) {
                return response.data;
            },
            function (response) {
                throw (response.data);
            });
    };

    self.setRetakeOptions = function (surveyId, retakeSetting) {
        return $http.post("api/survey/" + surveyId + "/retakeOptions", retakeSetting).then(function (response) {
                return response.data;
            },
            function (response) {
                throw (response.data);
            });
    };

}